// [BD feat] FAQ section BD variants — bd-faq.js
// The theme's accordion uses native <details>/<summary>; BD a11y rules ask for
// an explicit aria-expanded on every accordion toggle, so this mirrors the
// native open state onto each summary of the BD variants of sections/faq.liquid.
(function () {
  'use strict';

  function initScope(scope) {
    if (!scope || !scope.querySelectorAll) return;
    var summaries = scope.querySelectorAll('.bd-faq-variant .accordion__summary');
    if (!summaries.length) return;

    summaries.forEach(function (summary) {
      if (summary.hasAttribute('data-bd-aria-init')) return;
      var details = summary.closest('details');
      if (!details) return;

      var sync = function () {
        summary.setAttribute('aria-expanded', details.open ? 'true' : 'false');
      };

      summary.setAttribute('data-bd-aria-init', '');
      details.addEventListener('toggle', sync);
      sync();
    });
  }

  initScope(document);

  // Shopify theme editor support: re-init when the section is re-rendered
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector('.bd-faq-variant')) return;
    initScope(event.target);
  });
})();
// [/BD feat] FAQ section BD variants
